module.exports = __webpack_public_path__ + "static/media/facebook.6fb5025f.png";